import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './gallery-modal.scss';

export class GalleryModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func,
    options: PropTypes.object,
  };

  render() {
    const {
      options: { imagesArray, ...tailProps },
    } = this.props;
    const imagesList = (imagesArray || []).map((item) => (
      <div key={item.id}>
        <img src={item.displayUrl} alt={item.title || ''} />
      </div>
    ));
    return (
      <div className="gallery">
        <Carousel {...tailProps}>{imagesList}</Carousel>
      </div>
    );
  }
}
